import { useAuth } from '../../hooks/useAuth';
import { Button } from '../ui/button';
import { LogOut, User, Menu } from 'lucide-react';

interface HeaderProps {
  onMenuClick?: () => void;
}

export function Header({ onMenuClick }: HeaderProps) {
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <header className="h-16 bg-white border-b border-gray-200 flex items-center justify-between px-4 sm:px-6">
      {/* Mobile menu button */}
      {onMenuClick && (
        <button
          onClick={onMenuClick}
          className="lg:hidden p-2.5 rounded-md hover:bg-gray-100 transition-colors min-w-[44px] min-h-[44px] flex items-center justify-center"
          aria-label="Ouvrir le menu"
        >
          <Menu className="h-6 w-6 text-gray-700" />
        </button>
      )}

      <div className="flex-1 lg:block hidden">
        {/* Optional: breadcrumbs or page title here */}
      </div>

      <div className="flex items-center gap-2 sm:gap-4">
        {/* User info - hide email on mobile */}
        <div className="flex items-center gap-2 text-sm">
          <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center">
            <User className="w-4 h-4 text-gray-600" />
          </div>
          <div className="text-right hidden sm:block">
            <p className="font-medium text-gray-900 text-sm">
              {user?.name || user?.email}
            </p>
            <p className="text-xs text-gray-500">Administrateur</p>
          </div>
        </div>

        {/* Logout button - icon only on mobile */}
        <Button
          variant="outline"
          size="sm"
          onClick={handleLogout}
          className="gap-2"
        >
          <LogOut className="w-4 h-4" />
          <span className="hidden sm:inline">Déconnexion</span>
        </Button>
      </div>
    </header>
  );
}
